import { all } from 'redux-saga/effects';

import consultaNaturalidadeSaga from './consultarNaturalidade/saga';
// import consultaCEPSaga from './cep/saga';

export default all([consultaNaturalidadeSaga]);
